<div class="toggle-switch">
    <input type="checkbox" id="toggle" (change)="toggle()" [checked]="isChecked" />
    <label for="toggle" class="toggle-label">
      <span class="toggle-button"></span>
    </label>
  </div>